import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BsUpload } from 'react-icons/bs';
import { TailSpin } from 'react-loader-spinner';

const useStyles = makeStyles((theme) => ({
    uploadRectangle: {
        width: '90%',
        padding: '2%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#F3F6F9',
        marginBottom: '20px',
    },
    uploadTextPrimary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'rgba(187, 200, 8, 1)',
    },
    label: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'rgba(187, 200, 8, 1)',
        marginBottom: '20px',
    },
    iframe: {
        width: '100%',
        height: '600px',
        border: 'none',
    },
}));

const PDFViewer = ({ documentName, pdfUrl, loading }) => {
    const classes = useStyles();

    return (
        <div className={classes.uploadRectangle}>
            {loading ? (
                <TailSpin color="rgba(187, 200, 8, 1)" radius={"10px"} />
            ) : pdfUrl ? (
                <>
                    <div className={classes.label}>{documentName}</div>
                    <iframe src={pdfUrl} className={classes.iframe} title="PDF Viewer"></iframe>
                </>
            ) : (
                <>
                    <BsUpload style={{ color: 'rgba(187, 200, 8, 1)' }} size={40} />
                    <div className={classes.uploadTextPrimary}>
                        Chargement du document...
                    </div>
                </>
            )}
        </div>
    );
};

export default PDFViewer;
